import React from 'react';
import PropTypes from 'prop-types';
import { startFree } from '../../../utils/pricing';
import SendGridLink from '../../SendGridLink';
import { StyledCTA } from './styles';
import AirplaneSVG from '../../../assets/svg/cta/airplane-light.svg';

const ReadyToStartCTA = ({ theme }) => (
  <StyledCTA ctaTheme={theme}>
    <AirplaneSVG />
    <h4>Ready to start sending?</h4>
    <p>Free to get started. Free to send.</p>
    <div className="btn-list">
      <button
        onClick={startFree}
        title="Try for free"
        className="btn btn--reversed"
        data-gtm-track="true"
        data-gtm-event-type="cta"
        type="button"
      >
        Try for free
      </button>
      <SendGridLink
        to="/contact-us-form/"
        className="btn btn--transparent-secondary"
      >
        Talk to Sales
      </SendGridLink>
    </div>
  </StyledCTA>
);

ReadyToStartCTA.propTypes = {
  theme: PropTypes.oneOf(['blue', 'darkest-blue']),
};

ReadyToStartCTA.defaultProps = {
  theme: 'blue',
};

export default ReadyToStartCTA;
